import { moduleProviderFactory } from "mrb/core";
import { AdminCertifiedModeList, AdminCertifiedModeEdit } from "administration/certified-mode/pages";
import {
    AdminCertifiedModeListRouteStore,
    AdminCertifiedModeEditRouteStore,
} from "administration/certified-mode/stores";

(function () {
    moduleProviderFactory.module("administration").register({
        name: "CertifiedMode",
        routes: [
            {
                name: "master.administration.certified-mode",
                pattern: "/certified-mode",
                children: [
                    {
                        name: "master.administration.certified-mode.list",
                        pattern: "",
                        component: AdminCertifiedModeList,
                        store: AdminCertifiedModeListRouteStore,
                        data: {
                            title: "ADMINISTRATION.CERTIFIED_MODE.LIST.TITLE",
                        },
                    },
                    {
                        name: "master.administration.certified-mode.create",
                        pattern: "/create",
                        component: AdminCertifiedModeEdit,
                        store: AdminCertifiedModeEditRouteStore,
                    },
                    {
                        name: "master.administration.certified-mode.edit",
                        pattern: "/:id/edit",
                        component: AdminCertifiedModeEdit,
                        store: AdminCertifiedModeEditRouteStore,
                    },
                ],
            },
        ],
        menu: [
            {
                title: "ADMINISTRATION.MENU.CERTIFIED_MODE",
                order: 9,
                icon: "certified",
                route: "master.administration.certified-mode.list",
            },
        ],
    });
})();
